import { Component, type ErrorInfo, type ReactNode } from 'react';

import { type logger } from '@register-ui/utils';
import { ServiceUnavailable } from '../../widgets/service-unavailable';

interface ErrorBoundaryProps {
    children: ReactNode;
    fallback?: ReactNode;
    logger?: typeof logger;
}

interface ErrorBoundaryState {
    hasError: boolean;
    error: Error | null;
}

export class ErrorBoundary extends Component<
    ErrorBoundaryProps,
    ErrorBoundaryState
> {
    constructor(props: ErrorBoundaryProps) {
        super(props);

        this.state = {
            hasError: false,
            error: null,
        };
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        this.props.logger?.error(`${error}\n${errorInfo.componentStack}`);
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback ?? <ServiceUnavailable />;
        }

        return this.props.children;
    }
}
